import { render } from "./ToolbarSottoProgetto.vue?vue&type=template&id=2eb4cb08&ts=true"
import script from "./ToolbarSottoProgetto.vue?vue&type=script&lang=ts"
export * from "./ToolbarSottoProgetto.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__